import React from "react"
//import { func } from "prop-types"
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
class ToDoForm extends React.Component {
    state={
        title:""
    }
    onChange = (e) =>this.setState({title:e.target.value})
    onSubmit = (e) =>{
        e.preventDefault();
        this.props.addItem(this.state.title);
        this.setState({title : ''});
    }
    geetStyle = () =>{
        return{
            margin :"20px",
        }   
      
    }
   
    render() {
       
        return(
            <form onSubmit={this.onSubmit}>
                <center><div style={this.geetStyle()}>
                 <TextField  name="title" style={{marginRight:"20px",marginTop:"8px"}} required placeholder="Add Tasks" value={this.state.title} onChange={this.onChange}/> 
                <Button type="submit" value="Submit" className="bttn" style={{background:"#FFAF4D"}}>Submit</Button>
                </div></center>
            </form>
            
        )
    }
}

export default ToDoForm;